import { useEventBus } from '@vueuse/core'

const mediaLoadedBus = useEventBus('media-loaded')

export default function useImageLoad(evt) {
  mediaLoadedBus.emit({ id: evt.target.getAttribute('id'), progress: 1.0 })
}
